import { Getters } from 'vuex-smart-module';
import { PaymentMethods, PaymentMethodsTranslate } from '@/enums';
import { SelectItem } from '@/types';
import { get_common_payment_type } from '../services';
import OrderState from './state';
import { Orders } from '../types';

export default class OrderGetters extends Getters<OrderState> {
  get new_order() {
    return this.state.new_order;
  }

  get updated_delivery_detils() {
    return this.state.new_delivery_details;
  }

  get has_organization() {
    return this.getters.new_order.organization !== null;
  }

  get warehouse_id() {
    return this.getters.new_order.warehouse;
  }

  get project_id() {
    return this.getters.new_order.project_id;
  }

  get organization_id() {
    return this.getters.new_order.organization;
  }

  get selected_organization() {
    const org_id = this.state.new_order.organization;

    return this.state.order_organizations.find((org) => org.id === org_id) || null;
  }

  get selected_transport_company() {
    return this.state.new_order.transport_company_id;
  }

  get selected_delline_place() {
    return this.state.new_order.delline_place_id;
  }

  get is_clear_field() {
    return this.state.is_clear_field;
  }

  get payment_items(): SelectItem[] {
    const prepayment = {
      text: PaymentMethodsTranslate[PaymentMethods.PREPAYMENT],
      value: PaymentMethods.PREPAYMENT,
    };
    const deferment = {
      text: PaymentMethodsTranslate[PaymentMethods.DEFERMENT],
      value: PaymentMethods.DEFERMENT,
    };
    const additional_item: SelectItem = {
      text: PaymentMethodsTranslate[PaymentMethods.DEFERMENT_PREPAYMENT],
      value: PaymentMethods.DEFERMENT_PREPAYMENT,
      disabled: true,
    };
    const items = [prepayment];

    if (this.getters.selected_organization?.is_deferment_payment) {
      items.push(deferment);
    }

    return this.getters.selected_payment_types === PaymentMethods.DEFERMENT_PREPAYMENT
      ? [
        ...items,
        additional_item, // нужно только для формы "заполните данные"
      ]
      : items;
  }

  get selected_payment_types(): unknown {
    const items = this.state.new_order.products;

    if (items?.length) {
      if (this.getters.is_clear_field) {
        return;
      }
      return get_common_payment_type(items);
    }
    return this.state.last_order_info.payment_type?.slug;
  }

  get products_sorted() {
    const sortAsc = (a:Orders.OrderProductInfo, b:Orders.OrderProductInfo) => a.id - b.id;

    return this.state.order_details?.products?.sort(sortAsc) || [];
  }
}
